import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'

import {
  BOOKING_STEPS,
} from 'settings'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    width: '50%',
    minWidth: '400px',
  },
  stepper: {
    backgroundColor: 'transparent',
    padding: '0px',
  },
  step: {
    cursor: 'pointer',
  },
}))

const BookStepper = ({
  value,
  onChange,
}) => {
  const classes = useStyles()
  const activeStep = BOOKING_STEPS.findIndex(step => step.id == value) || 0
  return (
    <div className={ classes.root }>
      <div className={ classes.container }>
        <Stepper
          activeStep={ activeStep }
          className={ classes.stepper }
        >
          {BOOKING_STEPS.map((step, i) => (
            <Step
              key={step.id}
              className={ classes.step }
              onClick={ () => {
                // we are disabling this because
                // we need a way to hook into the
                // formik forms on each page
                // can send them off to the reservation
                // before we switch page
                //if(i <= activeStep) onChange(step.id)
              }}
            >
              <StepLabel>{step.title}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
    
  )
}

export default BookStepper